<template>
  <div
    :id="idString"
    class="tooltip-container"
  >
    <div
      ref="tooltip"
      :class="cls"
      @mouseenter="toggleDefault($event)"
      @mouseleave="toggleDefault2($event)"
    >
      <slot />
    </div>
    <DxTooltip
      class="ms-tooltips"
      :visible="mutaActive"
      :close-on-outside-click="false"
      :hide-on-parent-scroll="true"
      :target="popoverTarget"
      :position="position"
      :hover-state-enabled="true"
      @shown="initEvent"
    >
      <slot name="text" />
    </DxTooltip>
  </div>
</template>
<script>
import { DxTooltip } from "devextreme-vue/tooltip";

export default {
  name: "MsTooltip",
  components: {
    DxTooltip,
  },
  props: {
    showTooltips: {
      default: true,
      type: [Boolean],
    },
    color: {
      default: null,
      type: String,
    },
    position: {
      default: "top",
      type: String,
    },
    delay: {
      default: "0s",
      type: [Number, String],
    },
    active: {
      type: [Boolean],
      default: false,
    },
    visibleWhenMouseOverTooltip: {
      type: [Boolean],
      default: true,
    },
    idString: {
      default: null,
      type: String
    }
  },
  data: () => ({
    cls: "con-ms-tooltip",
    popoverTarget: null,
    mutaActive: false,
    tooltipMouseEntered: false,
  }),
  mounted() {},
  methods: {
    initEvent() {
      const me = this;
      document
        .getElementById(this.$refs.tooltip.getAttribute("aria-describedby"))
        .addEventListener("mouseleave", (event) => {
          setTimeout(() => {
            me.mutaActive = false;
            me.tooltipMouseEntered = false;
          }, 100);
        });

      document
        .getElementById(this.$refs.tooltip.getAttribute("aria-describedby"))
        .addEventListener("mouseenter", (event) => {
          if (me.visibleWhenMouseOverTooltip) {
            me.mutaActive = true;
            me.tooltipMouseEntered = true;
          }
        });
    },
    toggleDefault(event) {
      var me = this;
      this.popoverTarget = event.target;
      this.mutaActive = true;
      // khi active nó move ra ngoài <body></body> và ko có class này-dvquang2
      this.$nextTick(() => {
        if (me.$el) {
          var body = me.$el.querySelector(".dx-tooltip-wrapper");
          if (body) body.classList.add("ms-tooltips");
        }
        //$("body").find(".dx-tooltip-wrapper").addClass("ms-tooltips");
      });

      event.stopPropagation();
    },
    toggleDefault2(event) {
      const me = this;
      this.popoverTarget = event.target;

      setTimeout(() => {
        if (!me.tooltipMouseEntered) {
          me.mutaActive = false;
        }
      }, 100);
      event.stopPropagation();
    },
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/controls/msTooltip.scss";
.ms-tooltips.dx-tooltip-wrapper .dx-overlay-content .dx-popup-content {
  display: inline-block;
  padding: 9px 12px;
  font-size: 0.85em;
  line-height: normal;
  white-space: nowrap;
  background-color: #4e4e4e;
  color: white;
  border-radius: 4px;
}

.ms-tooltips.dx-tooltip-wrapper.dx-popover-wrapper .dx-popover-arrow::after {
  border: 1px solid #4e4e4e;
  background: #4e4e4e;
}
.dx-popover-wrapper.dx-position-top .dx-popover-arrow {
  width: 20px;
  height: 14px;
  //bottom: -8px !important;
}

.dx-popover-wrapper.dx-position-bottom .dx-popover-arrow {
  //top: -6px !important;
}

.ms-tooltips.dx-tooltip-wrapper .dx-overlay-content {
  border: none !important;
}
.dx-tooltip-content-custom {
  background-color: #4e4e4e !important;
}
</style>
